import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { Navigate, useNavigate } from 'react-router-dom';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect, useState } from 'react';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { MenuButtonGroup } from '@/components/features/SettingMenuButtonGroup';
import { StripePaymentElement } from '@/components/element/Form/StripePaymentElement';
import { toastSuccess } from '@/lib/toast';

export const EditPaymentMethod = () => {
  const { _w_, me } = useCurrentWorkspace();

  if (me?.admin) {
    return <_EditPaymentMethod />;
  } else {
    return <Navigate replace to={'/workspaces'} />;
  }
};

const _EditPaymentMethod = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('支払方法変更'), []);
  useEffect(() => setBreadcrumbs([{ label: `スペース設定`, path: `/w/${_w_!.identifier}/setting` }]), []);

  const navigate = useNavigate();
  const { _w_, me } = useCurrentWorkspace();
  const [paymentInfoUpdated, setPaymentInfoUpdated] = useState<boolean>(false);

  useEffect(() => {
    if (paymentInfoUpdated) {
      toastSuccess('支払方法の変更が完了しました');
      navigate(`/w/${_w_!.identifier}/setting`);
    }
  }, [paymentInfoUpdated]);

  return (
    <WorkspaceLayout>
      <div className="container-fluid py-4">
        <MenuButtonGroup selected={'basic'} />

        <div className="row">
          <div className="col-12 col-lg-9 mx-auto">
            <div className="card mb-4" id="basic-info">
              <div className="card-header d-flex align-items-center">
                <div className="col-md-12">
                  <h5 className="mb-1">支払方法変更</h5>
                  <p className="text-xs mb-0">
                    現在の契約の期間が残っている場合、 次回契約更新から指定した支払方法に切り替わります。
                  </p>
                </div>
              </div>

              <div className="card-body pt-0">
                <StripePaymentElement setPaymentInfoUpdated={setPaymentInfoUpdated} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
